(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  class DetailsPopup extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.closeButton = this.querySelector('[data-popup-close]');
      this.popup = this.querySelector('.comparison-table__popup');

      this.setupEventListeners();
    }

    setupEventListeners() {
      if (this.closeButton) {
        this.closeButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.close();
        });
      }

      if (this.popup) {
        document.addEventListener('click', (e) => {
          if (!this.popup.contains(e.target)) {
            this.close();
          }
        });
      }
    }

    close() {
      this.details.removeAttribute('open');
    }
  }

  if (!customElements.get('details-popup')) {
    customElements.define('details-popup', DetailsPopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      const isHomepage = document.body.classList.contains('template-index');
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.headerIsAlwaysSticky) {
        if (isHomepage && scrollTop <= 50) {
          this.header.classList.remove('shopify-section-header-sticky');
        } else {
          this.header.classList.add('shopify-section-header-sticky');
        }
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementBarHeight() {
      const announcementBar = document.querySelector('.announcement-bar-section, .utility-bar');
      if (announcementBar) {
        const height = announcementBar.offsetHeight;
        document.documentElement.style.setProperty('--announcement-bar-height', `${height}px`);
      } else {
        document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      }
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const isHomepage = document.body.classList.contains('template-index');

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      // Sur la homepage, on active le sticky dès qu'on scrolle
      if (isHomepage && scrollTop > 50) {
        this.header.classList.add('shopify-section-header-sticky');
      } else if (isHomepage && scrollTop <= 50) {
        this.header.classList.remove('shopify-section-header-sticky', 'shopify-section-header-hidden');
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top && !isHomepage) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      const isHomepage = document.body.classList.contains('template-index');
      
      if (isHomepage) {
        // Sur la homepage, on cache juste le header sans changer son état sticky
        this.header.classList.add('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      }
      this.closeMenuDisclosure();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      const isHomepage = document.body.classList.contains('template-index');
      
      if (isHomepage) {
        // Sur la homepage, on révèle juste le header
        this.header.classList.add('animate');
        this.header.classList.remove('shopify-section-header-hidden');
      } else {
        this.header.classList.add('shopify-section-header-sticky', 'animate');
        this.header.classList.remove('shopify-section-header-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      const isHomepage = document.body.classList.contains('template-index');
      
      if (!isHomepage) {
        this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
